import { useMemo } from 'react';

export const useFallbackKeys = <T>(items: T[]): { item: T; key: string }[] => {
  return useMemo(
    () =>
      items.map((item, i) => ({
        item,
        // Use crypto.randomUUID if available, otherwise fallback to a combination of index and random string (for very old browsers and devs using http instead of https)
        key: crypto.randomUUID ? crypto.randomUUID() : `${i}-${Math.random().toString(36).substring(2, 15)}`,
      })),
    [items]
  );
};
